import _ from 'underscore';
import $ from 'jquery';
import Personalizer from 'personalizer';
import MapConstants from 'constants/map/map';
import Util from 'views/utils/LeafletMap/utils/Util';
import DirectionService from 'views/utils/LeafletMap/MapServices/DirectionService';

// Only supports Riding, Walking
var TransitModeMapping = {
    CYCLING: 'riding',
    PEDESTRIAN: 'walking'
};

var ErrorCodeMap = {
    'The route distance is too long to calculate a route.': Util.ErrorCodes.ROUTE_TO_LONG,
    "One or more waypoints can't be routed because they are too far from any roads.":
        Util.ErrorCodes.ROUTE_TO_FAR_FROM_ROADS
};

var BaiduDirectionService = function(args) {
    DirectionService.call(this, args);

    return this;
};

BaiduDirectionService.prototype = Object.create(DirectionService.prototype);
BaiduDirectionService.prototype.constructor = BaiduDirectionService;

BaiduDirectionService.prototype.fetch = function fetch(options, context) {
    var travelMode = this.transitMode;
    if (TransitModeMapping[this.transitMode]) {
        travelMode = TransitModeMapping[this.transitMode];
    }

    var url = ['https://api.map.baidu.com/direction/v1?'];
    url.push('mode=' + travelMode);
    url.push('&coord_type=bd09ll');
    url.push('&ret_coordtype=bd09ll');
    url.push('&origin=' + options.start[0] + ',' + options.start[1]);
    url.push('&destination=' + options.end[0] + ',' + options.end[1]);
    url.push('&origin_region=');
    url.push('&destination_region=');
    url.push('&ak=' + MapConstants.baiduKey);
    url.push('&output=json');
    url.push('&callback=?');

    $.getJSON(url.join(''), function(response) {
        if (response.result) {
            if (!response.result.routes) {
                errorCall(options, response);
                return;
            }
            var route = response.result.routes[0],
                meters = options.isMetric
                    ? (route.distance / 1000) * Personalizer.ConversionFactors.KmToMeters
                    : (route.distance / 1000) * Personalizer.ConversionFactors.MilesToMeters,
                points = [];

            $.each(route.steps, function(i, step) {
                var path = step.path;
                var pathPoints = path.split(';');

                $.each(pathPoints, function(i, pathPoint) {
                    var latLng = pathPoint.split(',');
                    points.push([Number(latLng[1]), Number(latLng[0]), 0, 0]);
                });
            });

            options.success.call(context, { points: points, meters: meters });
        } else {
            errorCall(options, response);
        }
    }).fail(function(jqXHR, response, status) {
        options.error.call(context, response, status);
    });

    let errorCall = function(options, response) {
        let errorCode;

        if (response.status === 2 || response.status === 2002) {
            errorCode = Util.ErrorCodes.ROUTE_TO_LONG;
        } else {
            errorCode = Util.ErrorCodes.GENERIC;
        }

        options.error.call(context, errorCode, response.status, errorCode);
    };
};

export default BaiduDirectionService;
